const dateToString = (date) => {
  if (date) {
    const removeEmptyHour = date.split('T00')[0]
    const mom = { base: new Date(removeEmptyHour) }
    mom.time = mom.base.toLocaleTimeString('es-ES', {
      timeZone: 'Europe/Madrid',
      timeStyle: 'short'
    })
    const dateSplitted = mom.base
      .toISOString()
      .split('T')[0]
      .split('-')
      .reverse()
    mom.day = dateSplitted.join('/')
    if (mom.time.length === 4) {
      mom.time = `0${mom.time}`
    }
    mom.full = `${mom.day} ${mom.time}`
    mom.dayMin = `${dateSplitted[0]}/${dateSplitted[1]}`
    mom.withYear = `${dateSplitted[0]}/${dateSplitted[1]}/${dateSplitted[2]}`
    mom.withYearMinimal = `${dateSplitted[0]}/${
      dateSplitted[1]
    }/${dateSplitted[2].substring(2, 4)}`
    return mom
  }
  return {}
}

const getAge = (dateString) => {
  const today = new Date()
  const birthDate = new Date(dateString)
  const age = today.getFullYear() - birthDate.getFullYear()
  return age
}

const datesAreOnSameDay = (first, second) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate()

const getNextDayOfWeek = (fromDate, dayOfWeek) => {
  const date = new Date(fromDate.getTime())
  date.setDate(date.getDate() + ((dayOfWeek + 7 - date.getDay()) % 7))
  return date
}

export { dateToString, getAge, datesAreOnSameDay, getNextDayOfWeek }
